import { ColumnLayout, ColumnLayouts } from '../schema/enum/column-layouts';

export function getColumnSpanClass(alignment: ColumnLayout | undefined): string {
    switch (alignment) {
        case ColumnLayouts.CENTER_12:
            return 'col-span-12';
        case ColumnLayouts.CENTER_10:
            return 'col-span-10';
        case ColumnLayouts.CENTER_8:
            return 'col-span-8';
        case ColumnLayouts.LEFT_8_START_2:
            return 'col-span-8';
        default:
            return 'col-span-12';
    }
}

export function getColumnStartClass(alignment: ColumnLayout | undefined): string {
    switch (alignment) {
        case ColumnLayouts.CENTER_12:
            return 'col-start-1';
        case ColumnLayouts.CENTER_10:
            return 'col-start-2';
        case ColumnLayouts.CENTER_8:
            return 'col-start-3';
        case ColumnLayouts.LEFT_8_START_2:
            return 'col-start-2';
        default:
            return 'col-start-1';
    }
}